<div class="bg-card rounded-[28px] p-6 shadow-sm border border-gray-100 dark:border-foreground-tertiary w-full Box-border mb-6">

  <div class="flex flex-row items-center justify-between mb-8">
      <div class="flex text-lg items-center gap-2">
          <div class="w-8 h-8 rounded-full flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="#3B82F6" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"></path></svg>
          </div>
          <h2 class="text-foreground text-[20px] font-bold tracking-tight">Hydration</h2>
      </div>

      <div>
          <p-dropdown
              [options]="filterOptions"
              [(ngModel)]="selectedFilter"
              (onChange)="onFilterChange()"
              optionLabel="label"
              optionValue="value"
              styleClass="border-0 bg-gray-50 shadow-none text-[13px] font-bold rounded-full px-2 py-0 hover:bg-gray-100 focus:shadow-none min-w-[90px] dark:bg-card dark:border-foreground-tertiary text-foreground"
              dropdownIcon="pi pi-chevron-down text-xs">
          </p-dropdown>
      </div>
  </div>

  <div class="mb-8">
      <p class="text-[13px] text-gray-500 font-medium tracking-wide mb-1">Today's Progress</p>
      <div class="flex items-baseline gap-1">
          <h1 class="text-[34px] font-bold text-foreground leading-none tracking-tight">{{ formatLiters(todaysIntake) }} L</h1>
          <span class="text-[16px] text-gray-500 font-medium">/ {{ formatLiters(todaysGoal) }}</span>
      </div>
  </div>

  <div class="relative w-full h-[180px] mb-8">
      <div *ngIf="loading" class="absolute inset-0 flex justify-center items-center bg-white/50 z-10 dark:bg-card/50">
          <i class="pi pi-spin pi-spinner text-2xl text-[#3B82F6]"></i>
      </div>

      <!-- Goal target label explicitly painted mimicking UI -->
      <div class="absolute right-[5px] top-[15px] text-[11px] font-bold text-[#4368B1] tracking-widest z-0 flex items-center gap-2 pr-2">
          {{ formatLiters(todaysGoal) }}L Goal
      </div>

      <p-chart *ngIf="chartData" type="bar" [data]="chartData" [options]="chartOptions" height="180px"></p-chart>
  </div>

  <div class="border-t border-gray-100 dark:border-foreground-tertiary pt-6 text-[13px]">
      <div class="flex gap-3 text-gray-700 bg-[#Fdfdfd] border-b-transparent">
          <div class="mt-0.5"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" class="text-[#facc15]" stroke="#F5A623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg></div>
          <p class="leading-relaxed font-medium">
              {{ getHintText() }}
          </p>
      </div>
  </div>

</div>
